import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { getTenant, getToken, handleGraphQLErrors } from '../../../utils.js'
import { csvUrl, currencyFormatter } from '../CustomUtils'
import { useNavigate } from 'react-router-dom'
import { QUARTERLY_AUDIT_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import ReportGrid from '../ReportGrid.js'
import '../Custom.css'

const QUARTERLY_AUDIT_REPORT = gql(QUARTERLY_AUDIT_REPORT_QUERY)

export default function QuarterlyAuditReport({ location }) {
  console.log('QuarterlyAuditReport rendered:', location)

  const navigate = useNavigate()
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [errors, setErrors] = useState()

  useEffect(() => {
    async function submitSearch() {
      const params = new URLSearchParams(location.search)
      const inputs = JSON.parse(params.get('inputs'))
      if (inputs.outputToCSV && inputs.outputToCSV === 'Y') {
        delete inputs.outputToCSV
        const tenant = getTenant()
        function tokenSuccess (jwt) {
          const link = document.createElement('a')
          document.body.appendChild(link)
          link.href = `${process.env.REACT_APP_SERVER}/csv/${tenant}/custom/BosSci/quarterlyAuditReport/quarterly_audit_report.csv?inputs=${JSON.stringify(inputs)}&jwt=${jwt}`
          link.setAttribute('type', 'hidden')
          link.setAttribute('target', '_blank')
          link.click()
          navigate(`/custom/quarterly_audit_new.report?oldInputs=${JSON.stringify(inputs)}`)
        }
        function tokenError(error) {
          console.log('CSVLink: ', JSON.stringify(error))
          setErrors(error)
        }
        getToken(tokenSuccess, tokenError)
      } else {
        try {
          delete inputs.outputToCSV
          const { data, errors } = await window.apolloClient.query({ query: QUARTERLY_AUDIT_REPORT, variables: { inputs: inputs } })
          if (data.quarterlyAuditReport) {
            // remove the last column (caseId)
            for (let i = 0; i < data.quarterlyAuditReport.reportData.length; i++) {
              data.quarterlyAuditReport.reportData[i].pop()
            }
            setResults(data.quarterlyAuditReport)
          }
          if (errors) {
            setGraphQLErrors(errors)
          }
        } catch(err) {
          handleGraphQLErrors(err, setGraphQLErrors)
        }
      }
    }
    submitSearch()
  }, [navigate, location.search])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (errors) {
    <Alert color="danger">{errors}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const alignment = ['center', 'left', 'left', 'center', 'center', 'center', 'center', 'left', 'left', 'center', 'center', 'left', 'left', 'center', 'left', 'left', 'right']
    const columnFormatters = [
      { columnNumber: 17, formatter: currencyFormatter().format, align: 'right' },
    ]
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('BosSci/quarterlyAuditReport/quarterly_audit_report', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title={'Quarterly Audit Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} viewButtonDataIndex={0} location={location} alignment={alignment} columnFormatters={columnFormatters} />
          </tbody>
        </Table>
      </div>
    )
  }
}